<template>
	<symbol :id="`${prefix}logo`" viewBox="0 0 34 34">
		<path fill="#7047EB" d="M0 17c0-5.28 0-7.92.86-10A11.33 11.33 0 0 1 7 .86C9.08 0 11.72 0 17 0s7.92 0 10 .86A11.33 11.33 0 0 1 33.14 7c.86 2.08.86 4.72.86 10s0 7.92-.86 10A11.33 11.33 0 0 1 27 33.14c-2.08.86-4.72.86-10 .86s-7.92 0-10-.86A11.33 11.33 0 0 1 .86 27C0 24.92 0 22.28 0 17Z"/>
		<path fill="white" d="M3.4 21.25 20.4 0v8.68a4.07 4.07 0 0 0 4.07 4.07h5.85L13.32 34v-8.68a4.07 4.07 0 0 0-4.07-4.07H3.4Z"/>
	</symbol>
</template>

<script>
export default {
	name: 'NiIconSymbolLogo',


	props: {
		prefix: {
			type: String,
			required: true,
		},
	},
};
</script>
